import { vendorUrls } from '@/api/urls/vendor';

import { setApiOptions } from '@/utilities/services';
import { normalizeStoreQuery } from '@/utilities/storeFilters';

import { RequestResponseType } from '../../../../models';
import { PaginatedResponse } from '../../models';

import { api } from '@/api/client';
import { GetStoresServiceQueryParamType, StoreType } from '@/server/services/vendor/stores/models';
import { AxiosPromise } from 'axios';

export const getNearestStoresService = (
    queryParam: GetStoresServiceQueryParamType
): AxiosPromise<RequestResponseType<PaginatedResponse<StoreType>>> => {
    const options = setApiOptions(vendorUrls.getNearestStores, {
        queryParam: normalizeStoreQuery(queryParam)
    });
    return api({ ...options, method: 'GET' });
};
